// "Peça de novo": estado de um pedido antigo em relação ao cardápio de AGORA.
//
// Regra do dono (14/09/2026): tudo que estiver esgotado (produto, ingrediente,
// complemento de qualquer etapa) mostra ESGOTADO; escondido, apagado ou de
// categoria desativada mostra INDISPONÍVEL. Nos dois casos o card fica bloqueado —
// o cliente vê o motivo e não consegue adicionar ao carrinho (o backend também
// barra, mas aqui evita o 409 na cara do cliente).
//
// Fontes: `aVendaPorId` = /public/products (lista de venda: sem escondido, sem
// arquivado, sem categoria oculta, recortada por turno); `catalogoPorId` =
// /public/products/all (tudo, com `hidden` — que já vem true quando a categoria
// está escondida — e `available`).

export const BLOQUEIO = { ESGOTADO: "esgotado", INDISPONIVEL: "indisponivel" };

const idDoItem = (it) => it?.product_id || it?.id || null;

function statusProduto(id, nome, { aVendaPorId, catalogoPorId }) {
  const chave = String(id);
  const venda = aVendaPorId.get(chave);
  if (venda) {
    return venda.available === false ? { bloqueio: BLOQUEIO.ESGOTADO, nome } : null;
  }
  const catalogo = catalogoPorId.get(chave);
  if (!catalogo) return { bloqueio: BLOQUEIO.INDISPONIVEL, nome }; // apagado/arquivado
  if (catalogo.hidden === true) return { bloqueio: BLOQUEIO.INDISPONIVEL, nome }; // escondido ou categoria desativada
  if (catalogo.available === false) return { bloqueio: BLOQUEIO.ESGOTADO, nome };
  // Existe e está ativo, só não entra na lista de venda (insumo de etapa, ou
  // fora do turno): não é bloqueio permanente — o clique já avisa o horário.
  return null;
}

/** Devolve `{ bloqueio, nome }` do primeiro problema (INDISPONÍVEL vence ESGOTADO) ou null. */
export function statusPedidoAntigo(pedido, ctx) {
  if (!ctx?.aVendaPorId || !ctx?.catalogoPorId) return null;
  let esgotado = null;
  for (const it of pedido?.items || []) {
    const id = idDoItem(it);
    const candidatos = [];
    if (id) candidatos.push([id, it.nome || it.name || it.product_name || "Item"]);
    for (const sub of Array.isArray(it?.subitems) ? it.subitems : []) {
      if (sub?.product_id) candidatos.push([sub.product_id, sub.nome || sub.name || "complemento"]);
    }
    for (const [pid, nome] of candidatos) {
      const s = statusProduto(pid, nome, ctx);
      if (!s) continue;
      if (s.bloqueio === BLOQUEIO.INDISPONIVEL) return s;
      esgotado = esgotado || s;
    }
  }
  return esgotado;
}

export const rotuloBloqueio = (status) =>
  status?.bloqueio === BLOQUEIO.ESGOTADO ? "ESGOTADO" : "INDISPONÍVEL";

export function mensagemBloqueio(status) {
  const nome = status?.nome || "Um item";
  return status?.bloqueio === BLOQUEIO.ESGOTADO
    ? `"${nome}" está esgotado — esse pedido não pode ser repetido agora.`
    : `"${nome}" não está mais no cardápio — esse pedido não pode ser repetido.`;
}
